export default "__VITE_ASSET__Uy1RrvJK__"